import { BorderRadiusTokenValue } from 'designSystem/types';
import * as S from './styles';

interface BorderRadiusTokenPreviewProps {
	value: BorderRadiusTokenValue;
}

export const BorderRadiusTokenPreview = ({ value }: BorderRadiusTokenPreviewProps) => {
	const radius = value.length.px || value.length.numericValue * 16;
	return (
		<S.PreviewContainer>
			<S.RadiusBox borderRadius={radius} />
		</S.PreviewContainer>
	);
};
